module.exports = require('./lodash');


//////////////////
// WEBPACK FOOTER
// ./~/lodash/index.js
// module id = 387
// module chunks = 1